import { FieldUpdate } from "./field-update";

export class Sync {
    syncTokens: any
    newModelIds: any
    fieldUpdates: FieldUpdate[] = new Array(); 
}

